  <template lang="pug">
    v-stepper(v-model="e1")
      v-stepper-header
        v-stepper-step(:complete="e1 > 1" step="1") Detail Izin
        v-divider
        v-stepper-step(:complete="e1 > 2" step="2") Detail Pekerjaan
        v-divider
        v-stepper-step(:complete="e1 > 3" step="3") Pencegahan/Persyaratan Khusus

      v-stepper-items
        v-stepper-content(step="1")
          v-card(class="mb-12"
            height="auto")
              v-layout(row wrap)
                v-flex(xs4 sm3)
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Lampiran
                v-flex(xs7 sm5)
                  v-autocomplete(
                          class="inputDefault"
                          label="Pilih Lampiran" 
                          v-model="selectedLampiran" 
                          :items="myFilteredAttachment" 
                          no-data-text="No Data" 
                          color="blue-grey lighten-2" 
                          item-text="ipTitle"
                          id="fpgwl-lampiran" 
                          return-object
                          clearable
                          chips
                          multiple)
                v-flex(xs1 sm4)

                v-flex(xs4 sm3)
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Judul Pekerjaan
                v-flex(xs7 sm5)
                  v-text-field(id="fpgwl-judul pekerjaan" class="inputDefault" v-model='judulPekerjaan' label="Judul Pekerjaan")
                v-flex(xs1 sm4)

                v-flex(xs3 sm3) 
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Tanggal Perizinan
                v-flex(xs4 sm2)
                  v-menu(
                    v-model="startMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px")
                  
                    template(v-slot:activator="{ on }")
                      v-text-field(
                        v-model="startDate"
                        label="mulai dari"
                        prepend-icon="event"
                        id="fpgwl-tgl-izin-start"
                        readonly
                        v-on="on")
                    v-date-picker(id="fpgwl-tgl-picker-start" v-model="startDate" @input="clearDate" :min="todayDate")
                v-flex(xs4 sm2)
                  v-menu(
                    v-model="endMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px")
                  
                    template(v-slot:activator="{ on }")
                      v-text-field(
                        v-model="endDate"
                        label="sampai dengan"
                        prepend-icon="event"
                        id="fpgwl-tgl-izin-end"
                        readonly
                        v-on="on")
                    v-date-picker(id="fpgwl-tgl-izin-end" v-model="endDate" @input="endMenu = false" :min="startDate")
                v-flex(xs1 sm4)

                v-flex(xs4 sm3)
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Waktu (Jam)
                v-flex(xs4 sm2)
                  v-menu(
                    v-model="clockMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px")
                  
                    template(v-slot:activator="{ on }")
                      v-text-field(
                        v-model="waktuPengawalan"
                        label="Waktu"
                        prepend-icon="mdi-clock"
                        id="fpgwl-waktu"
                        readonly
                        v-on="on")
                    v-time-picker(id="fpgwl-waktu-picker" v-model="waktuPengawalan" format="24hr" scrollable)
                v-flex(xs4 sm2)
                v-flex(xs1 sm4)

                v-flex(xs4 sm3)
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Jenis Pengawalan
                v-flex(xs7 sm5)
                  v-radio-group(id="fpgwl-jenis-pengawalan" v-model="jenisPengawalan" row)
                    v-radio(id="fpgwl-jenis-pengawalan" label="Unit Baru Masuk" value="Unit Baru Masuk")
                    v-radio(id="fpgwl-jenis-pengawalan" label="Pindah Lokasi kerja" value="Pindah Lokasi Kerja")
                v-flex(xs1 sm4)

                v-flex(xs4 sm3) 
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Kategori
                v-flex(xs7 sm5)
                  v-autocomplete(
                          class="inputDefault"
                          label="Kategori" 
                          v-model="selectedCategory" 
                          :items="jobCategory" 
                          no-data-text="No Data" 
                          color="blue-grey lighten-2" 
                          item-text="text"
                          id="fpgwl-kategori"
                          item-value="value" 
                          clearable
                          chips
                          )
                v-flex(xs1 sm4)

                v-flex(xs4 sm3) 
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Pengawas Pengawalan
                v-flex(xs7 sm5)
                  v-text-field(
                    v-model="pemegangIzin.name"
                    id="fpgwl-pengawas-pengawalan"
                    readonly)
                v-flex(xs1 sm4)

                v-flex(xs4 sm3) 
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Perusahaan
                v-flex(xs7 sm5)
                  v-autocomplete(
                    class="inputDefault"
                    v-model="perusahaan"
                    id="fpgwl-perusahaan"
                    :items="dataUsers.companies"
                    label="Perusahaan")
                v-flex(xs1 sm4)

                v-flex(xs4 sm3) 
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Department
                v-flex(xs7 sm5)
                  v-row
                    v-col
                      v-autocomplete(
                        class="inputDefault"
                        v-model="deptDivisi"
                        id="fpgwl-dept-divisi"
                        :items="dataUsers.department"
                        label="Department")
                    v-col
                      v-text-field(id="fpgwl-divisi" class="inputDefault" v-model='divisi' counter="100" maxlength="100" label="Divisi")
                v-flex(xs1 sm4)
          v-btn(color="primary" @click="e1 = 2; scrollTop();" :disabled='!isPage1Complete') Continue
          v-btn(text @click="backHome()") Cancel

        v-stepper-content(step="2")
          v-card(class="mb-12"
            height="auto")
              v-layout(row wrap)
                v-flex(xs12 sm12) 
                    h3(class="headerSection") DESKRIPSI DETAIL PENGAWALAN
                    br
                v-flex( sm12)
                    div(style="margin: 0 15px 0 15px;padding: 0;}")
                      ckeditor(id="fpgwl-detail-pengawal" :editor="editor" v-model="detailPengawalan" :config="editorConfig")
                    br
          v-btn(class="mr-3" dark color='blue-grey' @click='backStep()') BACK
          v-btn(color="primary" @click="e1 = 3; scrollTop();") Continue
          v-btn(text @click="backHome()") Cancel

        v-stepper-content(step="3")
          v-card(class="mb-12"
          height="auto")
            v-layout(row wrap)
                v-flex(xs4 sm3)
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Jumlah iring-iringan unit
                v-flex(xs7 sm5)
                  v-text-field(cid="fpgwl-jumlah-unit" lass="inputDefault" v-model='jumlahUnit' label="Jumlah Unit")
                v-flex(xs1 sm4)

                v-flex(xs4 sm3) 
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Rute Pengawalan
                v-flex(xs7 sm5)
                  v-row
                    v-col
                      v-autocomplete(
                          prepend-inner-icon="mdi-map-marker"
                          class="inputDefault"
                          label="Rute Awal" 
                          id="fpgwl-rute-pengawalan"
                          v-model="lokasiAwal" 
                          :items="locations.data" 
                          no-data-text="No Data" 
                          color="blue-grey lighten-2" 
                          item-text="location_name" 
                          item-value="data" 
                          clearable
                          chips)
                    v-col
                      v-text-field(id="fpgwl-sublokasi-awal" class="inputDefault" v-model='subLokasiAwal' label="Sub Lokasi" counter="100" maxlength="100" height='42')
                v-flex(xs1 sm4)

                v-flex(xs4 sm3) 
                v-flex(xs7 sm5)
                  v-row
                    v-col
                      v-autocomplete(
                          prepend-inner-icon="mdi-map-marker"
                          class="inputDefault"
                          label="Menuju ke" 
                          id="fpgwl-lokasi-tujuan"
                          v-model="lokasiTujuan" 
                          :items="locations.data" 
                          no-data-text="No Data" 
                          color="blue-grey lighten-2" 
                          item-text="location_name" 
                          item-value="data" 
                          clearable
                          chips)
                    v-col
                      v-text-field(id="fpgwl-sublokasi-tujuan" class="inputDefault" v-model='subLokasiTujuan' label="Sub Lokasi" counter="100" maxlength="100" height='42')
                v-flex(xs1 sm4)

                v-flex(xs3 sm3) 
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Lamanya Pengawalan
                v-flex(xs4 sm2)
                  v-menu(
                    v-model="pengawalanDurationMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px")
                  
                    template(v-slot:activator="{ on }")
                      v-text-field(
                        v-model="pengawalanStartDuration"
                        id="fpgwl-pengawalan-start-duration"
                        label="mulai dari"
                        prepend-icon="mdi-clock"
                        readonly
                        v-on="on")
                    v-time-picker( id="fpgwl-pengawalan-start-picker" v-model="pengawalanStartDuration" format="24hr" scrollable)
                v-flex(xs4 sm2)
                  v-menu(
                    v-model="pengawalanEndMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px")
                  
                    template(v-slot:activator="{ on }")
                      v-text-field(
                        v-model="pengawalanEndDuration"
                        label="Sampai jam"
                        prepend-icon="mdi-clock"
                         id="fpgwl-pengawalan-end-duration"
                        readonly
                        v-on="on")
                    v-time-picker( id="fpgwl-pengawalan-end-picker" v-model="pengawalanEndDuration" format="24hr" scrollable)
                v-flex(xs1 sm4)

                v-flex(xs4 sm3)
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Lebar Keseluruhan Unit
                v-flex(xs7 sm2)
                  v-text-field( id="fpgwl-lebar-unit" class="inputDefault" v-model='lebarUnit' label="Lebar" suffix="M")
                v-flex(xs1 sm5)

                v-flex(xs4 sm3)
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Panjang Keseluruhan Unit
                v-flex(xs7 sm2)
                  v-text-field( id="fpgwl-penjang-unit" class="inputDefault" v-model='panjangUnit' label="Panjang" suffix="M")
                v-flex(xs1 sm5)

                v-flex(xs4 sm3)
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Tinggi Keseluruhan Unit
                v-flex(xs7 sm2)
                  v-text-field(id="fpgwl-tinggi-unit" class="inputDefault" v-model='tinggiUnit' label="Tinggi" suffix="M")
                v-flex(xs1 sm5)

                v-flex(xs4 sm3)
                  p(class="headerSection") 
                    span(class="mustFill") *
                    span  Berat Beban Unit
                v-flex(xs7 sm2)
                  v-text-field(id="fpgwl-berat-unit" class="inputDefault" v-model='beratUnit' label="Berat" suffix="Ton")
                v-flex(xs1 sm5)
                
                v-flex(xs5 sm3) 
                  h3(class="headerSection") Upload Dokumen
                v-flex(xs6 sm5 class="attachment" v-if="!docPendukung || docPendukung.size > 10000000")
                  v-file-input(id="fpgwl-documen" :rules="rules"  label="Hanya 1 file, max 10MB" v-model="docPendukung")
                    template(v-slot:selection="{ text }" )
                      v-chip(small label color="primary")   {{ text }}
                v-flex(xs6 sm5 class="attachmentName" v-if="docPendukung")
                  span(id="fpgwl-documen") {{docPendukung.name ? docPendukung.name : docName(docPendukung) }}
                  v-btn(icon color="red" @click="deleteDocPendukung('docPendukung')")
                    v-icon mdi-close
                v-flex(xs1 sm4)
                v-alert(
                  text
                  outlined
                  color="info"
                  type="info"
                  class="ml-4 mr-4"
                ) Silahkan upload dokumen berikut:
                  ol
                    li  Medical Check Up (MCU) Pengemudi atau Surat Keterangan Sehat Pengemudi dari instansi kesehatan dengan minimal mencakup tensi darah, kolesterol total, trigliserida, HDL, LDL, dengan masa berlaku selama 1 bulan terhitung dari tanggal pemeriksaan
                    li Foto 4 sisi unit 
                    li Jsa dan bukti pelaksanaan sosialisasi JSA 
                    li KTP dan SIM Pengemudi

          v-btn(class="mr-3" dark color='blue-grey' @click='backStep()') BACK
          v-btn(class="mr-3" color='info' @click='submit(1)')
            v-icon insert_drive_file
            | &nbsp; Save as Draft
          v-btn(v-if='!submitClick' color='success' @click='submit(2)' :disabled='!isPage3Complete')
            v-icon send
            | &nbsp; Submit Request
          v-btn(text @click="backHome()") Cancel
  </template>

  <script>
  import helper from "../helper/index.js";
  import axios from "axios";
  import { mapState } from "vuex";
  import { MyCustomUploadAdapterPlugin } from "../utils/MyUploadAdapter";
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import PemegangModal from "./PemegangModal.vue";
  import PermitUserModal from "./PermitUserModal.vue";
  export default {
    name: "AddKetinggian",
    components: {
      PemegangModal,
      PermitUserModal,
    },
    props: {
      edit: { type: Boolean, default: false },
      users: Array
    },
    data() {
      return {
        e1: 1,
        editor: ClassicEditor,
        editorConfig: {
          extraPlugins: [ MyCustomUploadAdapterPlugin ],
          removePlugins : ['ImageUpload','MediaEmbed'],
          toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'indent', 'outdent', '|', 'blockQuote', 'insertTable', 'undo', 'redo'],
          image: {
            // You need to configure the image toolbar, too, so it uses the new style buttons.
            toolbar: [ 'imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight' ],
            styles: [
                // This option is equal to a situation where no style is applied.
                'full',
                // This represents an image aligned to the left.
                'alignLeft',
                // This represents an image aligned to the right.
                'alignRight'
            ]
          }
        },


        // Start of Page 1:----------------
        formCode: 'BIB-HSE-PPO-F-012-01',
        selectedLampiran: [],
        judulPekerjaan: '',


        startMenu: false,
        startDate: '',
        endMenu: false,
        endDate: '',
        todayDate: new Date().toISOString().slice(0,10),

        clockMenu: false,
        waktuPengawalan: '',

        jenisPengawalan: '',

        jobCategory: [
          {text: "Kategori 1", value: 1},
          {text: "Kategori 2", value: 2},
          {text: "Kategori 3", value: 3},
          {text: "Kategori 4", value: 4}
        ],
        selectedCategory: '',

        searchPemegangMenu: false,

        perusahaan: '',

        deptDivisi: '',
        divisi: '',
        // End of Page 1 ------------------

        // Start of Page 2 ----------------
        detailPengawalan: '',
        // End of Page 2 ------------------
        
        
        // Start of Page 3 ---------------
        jumlahUnit: '',

        lokasiAwal: '',
        subLokasiAwal: '',
        lokasiTujuan: '',
        subLokasiTujuan: '',

        pengawalanDurationMenu: false,
        pengawalanStartDuration: '',

        pengawalanEndMenu: false,
        pengawalanEndDuration: '',

        lebarUnit: '',
        panjangUnit: '',
        tinggiUnit: '',
        beratUnit: '',
        // End of Page 3 -----------------


        temporaryAttachment: null,
        uploadId: null,
        docPendukung: null,
        submitClick: false,
        status: 0,
        rules: [
          value => !value || value.size < 10000000 || 'Ukuran file harus dibawah 10 MB!',
        ],
        emptyUpload: new File([""], "", {
          type: "",
        })
      };
    },
    mounted: async function() {
      this.$store.dispatch("fetchLocations");
      this.$store.dispatch("fetchMyAttachmentToAttach");
      const isFromList = this.$route.query.list === '1';
      if (isFromList && this.selectedAttachment.length > 0) {
        this.selectedLampiran = this.selectedAttachment;
      }
      this.$store.commit("setSelectedAttachment", []);
      this.uploadId = Date.now();
    },
    computed: {
      ...mapState(["API_URL", "locations", "dataUsers", "dataEditRequest", "myFilteredAttachment", "selectedAttachment"]),
      selectedLoc(){
        let tempLoc = []
        let locationCode;
        
        if(this.dataUsers.location instanceof Array){
          locationCode = this.dataUsers.location[0];
        }else{
          locationCode = this.dataUsers.location;
        }

        for(let i = 0; i < this.lokasi.length; i++){
          tempLoc.push({code: locationCode, name: this.lokasi[i]});
        }
        return tempLoc
      },
      isPage1Complete: function() {
        return (this.selectedLampiran.length > 0) && this.judulPekerjaan && this.divisi && this.startDate && this.endDate && this.waktuPengawalan && this.jenisPengawalan && this.selectedCategory && this.pemegangIzin && this.deptDivisi && this.perusahaan;
      },
      isPage3Complete() {
        return this.jumlahUnit && this.lokasiAwal && this.lokasiTujuan && this.subLokasiAwal && this.subLokasiTujuan && this.pengawalanStartDuration && this.pengawalanEndDuration && this.lebarUnit && this.panjangUnit && this.tinggiUnit && this.beratUnit;
      },
      userRole() {
        const roleObject = {
          "Unit Baru Masuk": {
            "1": {
              "HO": ['SECHEAD'],
              "MITRA": ['PJO'],
              "PH3": ['PJO']
            },
            "2": {
              "HO": ['DIC'],
              "MITRA": ['PJO'],
              "PH3": ['PJO']
            },
            "3": {
              "HO": ['DIVHEAD'],
              "MITRA": ['PJO'],
              "PH3": ['PJO']
            },
            "4": {
              "HO": ['DIVHEAD'],
              "MITRA": ['PJO'],
              "PH3": ['PJO']
            },
          },
          "Pindah Lokasi Kerja": {
            "1": {
              "HO": ['SECHEAD'],
              "MITRA": ['PJO'],
              "PH3": ['PJO']
            },
            "2": {
              "HO": ['SECHEAD'],
              "MITRA": ['PJO'],
              "PH3": ['PJO']
            },
            "3": {
              "HO": ['SECHEAD'],
              "MITRA": ['PJO'],
              "PH3": ['PJO']
            },
            "4": {
              "HO": ['DIC'],
              "MITRA": ['PJO'],
              "PH3": ['PJO']
            },
          }
        };
        return roleObject[this.jenisPengawalan][this.selectedCategory.toString()][this.dataUsers.location[0]];
      },
      pemegangIzin() {
        const lampirans = this.selectedLampiran;
        if (lampirans.length > 0) {
          const pengawas = lampirans.map((val) => val.ipPengetahu.name);
          const positions = lampirans.map((val) => val.ipPengetahu.title);
          const uniquePengawas = pengawas.filter((value, index, self) => {
            return self.indexOf(value) === index;
          });
          const uniquePositions = positions.filter((value, index, self) => {
            return self.indexOf(value) === index;
          });
          return { name: uniquePengawas.join(', '), title: uniquePositions.join(', ') }
        }
        return '';
      },
    },
    methods: {
      clearDate(){
        this.endDate=null;
        this.startMenu = false;
      },
      formatDate:helper.formatDate,
      scrollTop(){
        window.scrollTo(0,0);
      },
      submit(status){
        this.submitClick = true;
        this.status = status;

        let formData = new FormData();
        if (this.edit) {
          formData.append('_id', this.dataEditRequest._id);
          formData.append('ipNo', this.dataEditRequest.ipNo);
          formData.append('ipWorkflow', JSON.stringify(this.dataEditRequest.ipWorkflow));
          formData.append('temporaryAttachment', JSON.stringify(this.temporaryAttachment));
        }
        formData.append('ipStatus', this.status);
        for(const i in this.selectedLampiran) {
          this.selectedLampiran[i].ipPengaju = this.pemegangIzin;
        }
        formData.append('ipLinkedAttachment', JSON.stringify(this.selectedLampiran));
        formData.append('ipJudulPekerjaan', this.judulPekerjaan);
        formData.append('ipTanggalPerizinanStart', this.startDate);
        formData.append('ipTanggalPerizinanEnd', this.endDate);
        formData.append('ipWaktuPengawalan', this.waktuPengawalan);
        formData.append('ipJenisPengawalan', this.jenisPengawalan);
        formData.append('ipSelectedCategory', this.selectedCategory);
        formData.append('ipPemegangIzin', JSON.stringify(this.pemegangIzin));
        formData.append('ipPerusahaan', this.perusahaan);
        formData.append('ipDeptDivisi', this.deptDivisi);
        formData.append('ipDivisi', this.divisi);
        formData.append('ipLocation', JSON.stringify([{code: this.dataUsers.location[0], name: ''}]));

        formData.append('ipDetailPengawalan', this.detailPengawalan);

        formData.append('ipJumlahUnit', this.jumlahUnit);
        formData.append('ipLokasiAwal', this.lokasiAwal);
        formData.append('ipSublokasiAwal', this.subLokasiAwal);
        formData.append('ipLokasiTujuan', this.lokasiTujuan);
        formData.append('ipSublokasiTujuan', this.subLokasiTujuan);
        formData.append('ipStartPengawalan', this.pengawalanStartDuration);
        formData.append('ipEndPengawalan', this.pengawalanEndDuration);
        formData.append("ipLebarUnit", this.lebarUnit);
        formData.append('ipPanjangUnit', this.panjangUnit);
        formData.append('ipTinggiUnit', this.tinggiUnit);
        formData.append('ipBeratUnit', this.beratUnit);

        formData.append('uploadId', this.uploadId );
        formData.append('ipUser', JSON.stringify(this.dataUsers) );
        formData.append('ipForm', this.formCode);

        const config = {
          method: this.edit ? "put" : "post",
          url: `${this.API_URL}/v1/requests`,
          headers: {"Content-Type": "multipart/form-data", "Authorization": `Bearer ${this.$store.state.token}`},
          data: formData
        };
        axios(config).then(res => {
          this.$store.commit("temporaryData", res);
          this.$router.push("/my-permit");
        });
      },
      // upload(name, paramFile){
      //   if(paramFile == undefined) return ;
      //   if(paramFile.size > 10000000){
      //     paramFile = null;
      //     if(name == 'docPendukung'){
      //       this.docPendukung = this.emptyUpload;
      //     }
      //     return
      //   }else{
      //     let formData = new FormData();
      //     formData.append('uploadId', this.uploadId );
      //     formData.append(name, paramFile );
      //     axios.post(`${this.API_URL}/v1/requests/attachment/${name}`, formData, {headers: {"Authorization": `Bearer ${this.$store.state.token}`}});
      //   }      
      // },
      deleteDocPendukung(name){
        let id = this.uploadId.toString();      
        this.$store
          .dispatch("deleteFile", {
            uploadId: id,
            folderName: name,
          })
          .then(() => {
            this.docPendukung = null;
          })
          .catch(() => {
            this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
          });
      },
      backHome(){
        this.$router.push("/my-permit");
      },
      backStep(){
        this.e1--
      },
      docName(name){
        return this.$setFilename(name);
      }
    },
    watch: {
      docPendukung(params){
        if(params && params.size < 10000000){
          let formData = new FormData();
          formData.append('uploadId', this.uploadId );
          formData.append('docPendukung', params );
          axios.post(`${this.API_URL}/v1/requests/attachment/docPendukung`, formData, {headers: {"Authorization": `Bearer ${this.$store.state.token}`}});
        }
    },
      dataEditRequest: async function() {
        await this.$store.dispatch("fetchMyAttachmentToAttach", this.dataEditRequest.ipNo);
        this.temporaryAttachment = this.dataEditRequest.ipLinkedAttachment;
        this.selectedLampiran = this.dataEditRequest.ipLinkedAttachment;
        this.judulPekerjaan = this.dataEditRequest.ipJudulPekerjaan;
        this.startDate = this.dataEditRequest.ipTanggalPerizinanStart;
        this.endDate = this.dataEditRequest.ipTanggalPerizinanEnd;
        this.waktuPengawalan = this.dataEditRequest.ipWaktuPengawalan;
        this.jenisPengawalan = this.dataEditRequest.ipJenisPengawalan;
        this.selectedCategory = parseInt(this.dataEditRequest.ipSelectedCategory);
        this.pemegangIzin = this.dataEditRequest.ipPemegangIzin;
        this.perusahaan = this.dataEditRequest.ipPerusahaan;
        this.deptDivisi = this.dataEditRequest.ipDeptDivisi;
        this.divisi = this.dataEditRequest.ipDivisi;
        this.location = this.dataEditRequest.ipLocation;


        this.detailPengawalan = this.dataEditRequest.ipDetailPengawalan;

        this.jumlahUnit = this.dataEditRequest.ipJumlahUnit;
        this.lokasiAwal = this.dataEditRequest.ipLokasiAwal;
        this.subLokasiAwal = this.dataEditRequest.ipSublokasiAwal;
        this.lokasiTujuan = this.dataEditRequest.ipLokasiTujuan;
        this.subLokasiTujuan = this.dataEditRequest.ipSublokasiTujuan;
        this.pengawalanStartDuration = this.dataEditRequest.ipStartPengawalan;
        this.pengawalanEndDuration = this.dataEditRequest.ipEndPengawalan;
        this.lebarUnit = this.dataEditRequest.ipLebarUnit;
        this.panjangUnit = this.dataEditRequest.ipPanjangUnit;
        this.tinggiUnit = this.dataEditRequest.ipTinggiUnit;
        this.beratUnit = this.dataEditRequest.ipBeratUnit;
        
        this.uploadId = this.dataEditRequest.uploadId;
        this.docPendukung = this.dataEditRequest.ipAttachmentFiles.docPendukung;
      },
    }
  };
  </script>

  <style>
  .ck-editor__editable {
      min-height: 300px;
      max-height: 300px;
      resize:none;
  }
  .mustFill {
    color: #EA5164;
  }
  </style>
